var EcommerceTracking = {
    mapProductProperties: false,
    data: {
        Products: {}
    },
    events: [],
    initialize: function () {
        this.bindEvents();
    },
    trackEvent: function (eventName, data) { },
    productClick: function (data) { },
    addProductToCart: function (data) { },
    removeProductFromCart: function (data) { },
    promoClick: function (data) { },
    promoView: function (data) { },
    viewProducts: function (data) { },
    productImpressions: function (data) { },
    getProductData: function (productId) {
        var productData = false,
            $dataObject = $('[name="ec-data"][data-ec-item="product"][data-ec-id="' + productId + '"], [name="ec-data"][data-ec-item="Products"][data-ec-id="' + productId + '"]');

        if (typeof this.data['Products'] !== 'undefined') {
            if (typeof this.data['Products'][productId] !== 'undefined') {
                productData = this.mapData(this.data['Products'][productId]);
            }
        }

        if ($dataObject.size() > 0 && $dataObject.val()) {
            productData = this.mapData(this.prepareInputDataValue($dataObject.val()));
        }

        return productData;
    },
    __addProductToCart: function (data) {
        if (data.response !== undefined) {
            data = data.response;
        }

        if (!data.status) {
            return;
        }

        var productId = data.item.product_id,
            productData = this.getProductData(productId);

        if (!productData) {
            return;
        }

        productData.quantity = data.item.added_quantity;
        if (data.selected_variation_values) {
            productData.variantName = _.pluck(data.selected_variation_values, 'name').join(', ');
        }

        this.events.push({
            'name': 'addProductToCart',
            'product': productData
        });

        this.addProductToCart(productData);
    },
    __removeProductFromCart: function (data) {
        if (data.response !== undefined) {
            data = data.response;
        }

        var productId = data.item.product_id,
            productData = this.getProductData(productId);

        if (!productData) {
            return;
        }

        productData.quantity = data.item.quantity;

        this.events.push({
            'name': 'removeProductFromCart',
            'product': productData
        });

        this.removeProductFromCart(productData);
    },
    __updateProductQuantity: function (product) {
        var productId = product.product_id,
            productData = this.getProductData(productId);

        if (!productData) {
            return;
        }

        var diffQuantity = product.quantity - product.old_quantity;

        productData.quantity = Math.abs(diffQuantity);

        this.events.push({
            'name': 'updateProductCartQuantity',
            'product': productData
        });

        if (diffQuantity > 0) {
            this.addProductToCart(productData);
        }

        if (diffQuantity < 0) {
            this.removeProductFromCart(productData);
        }
    }
};

EcommerceTracking.prepareInputDataValue = function (data) {
    return JSON.parse(data.replace(/\'/g, "\""));
};

// map data
EcommerceTracking.mapData = function (tempData) {
    var data = {};

    if (this.mapProductProperties) {
        _.each(this.mapProductProperties, function (value, key) {
            if (key == 'productCurrency') {
                data[value] = Eshop.options.currency.code;
            }

            if (tempData[key]) {
                var tmpValue = tempData[key];

                if (key == 'productPrice') {
                    tmpValue = parseFloat(tmpValue);
                }

                data[value] = tmpValue;
            }
        });
    }

    return !_.isEmpty(data) ? data : tempData;
};

// parse EC data from input element
EcommerceTracking.parseEcData = function (elem) {
    if (!elem) {
        return {};
    }

    var $elem = $(elem),
        $dataObject = $('[name="ec-data"][data-ec-item="' + $elem.data('ec-item') + '"][data-ec-id="' + $elem.data('ec-id') + '"]');

    if ($dataObject.size() == 0 && this.data[$elem.data('ec-item')] != undefined) {
        if (this.data[$elem.data('ec-item')][$elem.data('ec-id')] != undefined) {
            return this.mapData(this.data[$elem.data('ec-item')][$elem.data('ec-id')]);
        }
    }

    if (!$dataObject.val()) {
        return false;
    }

    return this.mapData(this.prepareInputDataValue($dataObject.val()));
};

EcommerceTracking.bindEvents = function () {
    var trackingObject = this;

    // Product click event
    $("body").delegate("[data-ec-action = \"clickProduct\"], [data-ec-item=\"Products\"]", "click", function () {
        var data = trackingObject.parseEcData(this);

        if (data) {
            trackingObject.productClick(data);

            trackingObject.events.push({
                'name': 'productClick',
                'product': data
            });
        }
    });

    $("body").delegate("a:not([data-ec-action])[href]:not([href=\"#\"])", 'click', function () {
        var $this = $(this),
            href = $this.attr('href'),
            productDetailMatch = href.match(/\/p\/(\d+)\/\w+|\w+-p(\d+)/),
            removeFromCartMatch = href.match(/\/remove-item\/(.*)/);

        if (productDetailMatch) {
            var id = productDetailMatch[1] ? productDetailMatch[1] : productDetailMatch[2];

            $this
                .attr("data-ec-action", "clickProduct")
                .attr("data-ec-item", "Products")
                .attr("data-ec-id", id);

            var data = trackingObject.parseEcData(this);

            if (data) {
                trackingObject.productClick(data);

                trackingObject.events.push({
                    'name': 'productClick',
                    'product': data
                });
            }
        }
    });

    // Promo click
    $("[data-ec-action = \"clickPromo\"], [data-ec-item=\"promo\"]").bind("click", function () {
        var $this = $(this),
            data = trackingObject.parseEcData(this);

        if (!data && $this.attr('data-ec-data')) {
            data = JSON.parse($this.attr('data-ec-data').replace(/\'/g, "\""));
        }
        trackingObject.promoClick(data);

        trackingObject.events.push({
            'name': 'promoClick',
            'product': data
        });
    });

    // Product view
    if ($("[data-ec-action = \"viewProduct\"]").size()) {
        var ecProducts = [];
        $("[data-ec-action = \"viewProduct\"]").each(function () {
            ecProducts.push(trackingObject.parseEcData(this));
        });
        trackingObject.viewProducts(ecProducts);

        trackingObject.events.push({
            'name': 'viewProduct',
            'product': ecProducts
        });
    }

    // Product view
    if ($("[data-ec-item = \"promo\"]").size()) {
        var ecPromotions = [];
        $("[data-ec-item = \"promo\"]").each(function () {
            ecPromotions.push(JSON.parse($(this).data('ec-data').replace(/'/g, '"')));
        });
        trackingObject.promoView(ecPromotions);

        trackingObject.events.push({
            'name': 'viewPromo',
            'product': ecPromotions
        });
    }

    // Product impressions
    var productImpressions = [],
        i = 0;

    for (var productId in trackingObject.data.Products) {
        if (typeof trackingObject.data.ProductsSorted !== 'undefined') {
            productId = trackingObject.data.ProductsSorted[i++];
        }

        productImpressions.push(trackingObject.mapData(trackingObject.data.Products[productId]));
    }
    if (productImpressions.length > 0) {
        trackingObject.productImpressions(productImpressions);

        trackingObject.events.push({
            'name': 'productImpressions',
            'product': productImpressions
        });
    }

    // vue event
    rEvent.on('Cart.addedProduct', function ({ response }) {
        trackingObject.__addProductToCart(response);
    });
    // old cart object event
    rEvent.on('Cart.product.after_add', function (response) {
        trackingObject.__addProductToCart(response);
    });

    // vue event
    rEvent.on('Cart.removedProduct', function ({ response }) {
        trackingObject.__removeProductFromCart(response);
    });
    // old cart object event
    rEvent.on('Cart.product.removed', function (response) {
        trackingObject.__removeProductFromCart(response);
    });

    // vue event
    rEvent.on('Cart.product.updated', function (product) {
        trackingObject.__updateProductQuantity(product);
    });
    // old cart object event
    rEvent.on('Cart.updatedProduct', function ({ response }) {
        trackingObject.__updateProductQuantity(response.item);
    });
}

$(function () {
    setTimeout(function () {
        if (typeof RshopApp === 'undefined' || !RshopApp._isMounted) {
            $.get(Eshop.options.baseUrl + 'cart/fetch-products', {}, function (response) {
                rEvent.dispatch('Cart.fetchedProducts', {
                    response: response
                });
            }, 'json');
        }
    }, 1000);
})

rEvent.on('Cart.fetchedProducts', function ({ response }) {
    if (!response.data.count) {
        return
    }

    for (var productId in response.data.items) {
        var product = response.data.items[productId];
        var variantName = "";

        if (Object.keys(product).length === 0) {
            continue;
        }

        if (product.has_variations && product.selected_variation_values) {
            if (Array.isArray(product.selected_variation_values)) {
                variantName = product.selected_variation_values.map(function (variationValue) {
                    return variationValue.name
                }).join(", ");
            } else {
                var variantNameArray = []
                for (const variationId in product.selected_variation_values) {
                    variantNameArray.push(product.selected_variation_values[variationId].name)
                }

                variantName = variantNameArray.join(", ");
            }
        }

        EcommerceTracking.data['Products'][productId] = {
            categoryName: product.category.name,
            manufacturerName: product.manufacturer ? product.manufacturer.name : "",
            productId: productId,
            productName: product.name,
            productPrice: product.price_vat,
            productPriceNoVat: product.price,
            productStatus: product.status,
            variantName: variantName,
            productTax: product.tax
        }
    }

    rEvent.dispatch('Tracking.fetchedCartProducts');
});
